<template>
  <div class="addedit-lead">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_lead') : $t('labels.add_lead') }}</h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-lead-card">
        <!-- Contact Details start -->
        <h3>{{ $t('labels.contact_detail') }}</h3>
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{$t('labels.organisation_name')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="organisation_name"
              maxlength="255"
              v-model="organisation_name"
              icon-no-border
              :placeholder="$t('labels.organisation_name')"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pr-0">
            <label>{{$t('labels.contact_name')}}</label>
            <vs-input
              v-validate="'required'"
              name="contact_name"
              type="text"
              class="w-full mt-1"
              maxlength="255"
              v-model="contact_name"
              icon-no-border
              :placeholder="$t('labels.contact_name')"
            />
            <span class="text-danger text-sm">{{ errors.first('contact_name') }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{$t('labels.email')}}</label>
            <vs-input
              v-validate="'email'"
              type="text"
              maxlength="255"
              class="w-full mt-1"
              name="email"
              v-model="email"
              icon-no-border
              :placeholder="$t('labels.email')"
            />
            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-6 pr-0">
            <label>{{$t('labels.phone')}}</label>
            <vs-input
              v-validate="{regex : /^(\+|\d)[0-9](\-|\d){7,16}$/}"
              maxlength="15"
              type="text"
              class="w-full mt-1"
              name="phone"
              v-model="phone"
              icon-no-border
              :placeholder="$t('labels.phone')"
            />
            <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
          </div>
        </div>
        <!-- Contact Details End -->
        <!-- Vessel Details start -->
        <h3>{{ $t('labels.vessel_detail') }}</h3>
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{$t('labels.name')}}</label>
            <vs-input
              type="text"
              maxlength="255"
              class="w-full mt-1"
              name="name"
              v-model="name"
              icon-no-border
              :placeholder="$t('labels.name')"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 pr-0">
            <div class="vx-row m-0">
              <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
                <label>{{$t('labels.imo_number')}}</label>
                <vs-input
                  v-validate="'alpha_num'"
                  type="text"
                  maxlength="7"
                  class="w-full mt-1"
                  name="imo_number"
                  v-model="imo_number"
                  icon-no-border
                  :placeholder="$t('labels.imo_number')"
                />
                <span class="text-danger text-sm">{{ errors.first('imo_number') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 mb-4 pr-0">
                <label>{{ $t('labels.date_of_attendence') }}</label>
                <datepicker placeholder="Select Date" v-model="date" class="mt-1"></datepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 pl-0">
            <label>{{ $t('labels.port_detail') }}</label>
            <vs-textarea
              type="text"
              maxlength="1000"
              name="port_detail"
              v-model="port_detail"
              class="port-detail mt-1"
              :placeholder="$t('strings.write_port_details')"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 agent-detail pr-0">
            <label>{{ $t('labels.agent_detail') }}</label>
            <vs-textarea
              type="text"
              maxlength="1000"
              v-model="agent_detail"
              name="agent_detail"
              class="mt-1"
              :placeholder="$t('strings.write_agents_details')"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-8 sm: mt-4 md:mt-0 pl-0">
            <label>{{ $t('labels.service_requirement') }}</label>
            <vs-textarea
              type="text"
              maxlength="1000"
              v-model="service_requirement"
              name="service_requirement"
              class="mb-0 mt-1"
              :placeholder="$t('strings.write_service_requirements')"
            />
          </div>
        </div>
        <!-- Vessel Details End -->
        <!-- Other Detail start -->
        <h3>{{ $t('labels.other') }}</h3>
        <div class="vx-row w-full m-0 mb-2">
          <div class="vx-col sm: w-full md:w-1/2 pl-0">
            <label>{{ $t('labels.remarks') }}</label>
            <vs-textarea
              type="text"
              maxlength="1000"
              class="mt-1"
              v-model="remarks"
              :placeholder="$t('strings.add_remarks')"
            />
          </div>
        </div>
        <!-- Other Detail end -->
        <div class="btn-lead flex justify-center">
          <vs-button
            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="create-lead"
            button="submit"
          >{{ editRoute ? $t('labels.update_lead') : $t('labels.add_lead') }}</vs-button>
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";

export default {
  data: () => ({
    organisation_name: "",
    name: "",
    phone: "",
    contact_name: "",
    email: "",
    imo_number: "",
    date: null,
    remarks: "",
    service_requirement: "",
    port_detail: "",
    agent_detail: ""
  }),
  components: {
    Datepicker
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getLeads();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateLead();
        }
      });
    },
    // Call API for add/edit Lead
    async createUpdateLead() {
      let input = {
        organisation_name: this.organisation_name,
        phone: this.phone,
        name: this.contact_name,
        email: this.email,
        vessel_name: this.name,
        vessel_imo_number: this.imo_number,
        vessel_date_of_attendence: this.date,
        vessel_service_requirements: this.service_requirement,
        vessel_port_details: this.port_detail,
        vessel_agent_details: this.agent_detail,
        remarks: this.remarks
      };
      let url = this.editRoute
        ? "/leads/update/" + this.editRoute
        : "/leads/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-lead",
        true
      );
      if (response) {
        this.$router.push({ name: "Leads" });
      }
    },
    async getLeads() {
      let response = await this.getHTTPGetResponse(
        "/leads/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let lead = data.lead;
        if (!lead) return;
        this.organisation_name = lead.organisation_name;
        this.phone = lead.phone;
        this.contact_name = lead.name;
        this.email = lead.email;
        this.name = lead.vessel_name;
        this.imo_number = lead.vessel_imo_number;
        this.date = lead.vessel_date_of_attendence;
        this.service_requirement = lead.vessel_service_requirements;
        this.port_detail = lead.vessel_port_details;
        this.agent_detail = lead.vessel_agent_details;
        this.remarks = lead.remarks;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
h3 {
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 10px;
  /* text-decoration: underline; */
}
</style>